export default __webpack_public_path__ + "static/media/seating1.fad2ebde.jpg";